import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';

angular.module('webTools').directive('wtMultiselect', ['$timeout', '$rootScope', '$window', '$q', '$document', 'CharacterThreshold', function ($timeout, $rootScope, $window, $q, $document, CharacterThreshold) {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            wtDataSource: '&',
            defaultValue: '=?',
            linkedParent: '=',
            autoBind: '=',
            autoPopulate: '=',
            typeToBind: '=',
            serverFiltering: '=',
            clearInput: '=',
            filterList: '=',
            model: '=?ngModel',
        },
        template: '<div class="multiselect property-input" wt-type="multi">' +
                    '<div id="multiselectStatus" class="multiselect-arrow"></div>' +
                    '<div class="multiselected clearfix">' +
                        '<div ng-repeat="item in model" id="{{item.id}}" class="multiselected-box">' +
                            '<span class="multi-value">{{item.text}}</span>' +
                            '<div class="multiselected-box-close" ng-click="removeItem($event, item.id);">x</div>' +
                        '</div>' +
                        '<input type="text" class="multiselect-input" ng-model="inputText" />' +
                        '<span class="widthSpan hidden">{{inputText}}</span>' +
                    '</div>' +
                  '</div>',
        link: function (scope, element, attributes) {

            var w = angular.element($window);
            scope.textBox = element.children('.multiselected').children('.multiselect-input');

            scope.inputText = '';

            if (scope.clearInput === true) { scope.textBox.bind('blur', function () { scope.$apply(function () { scope.inputText = ''; }) }); }

            scope.list = angular.element('<div class="multiselect-list hidden"><ul></ul></div>');

            scope.model = scope.model || [];

            $document.find('body').append(scope.list);

            scope.$on('$destroy', function () {
                scope.list.remove();
            })

            var el = scope.list.children('ul');

            scope.list.bind('mousedown click', function (e) { e.stopPropagation(); e.preventDefault();})
           
            if (scope.linkedParent) {

                scope.linkedParent = scope.linkedParent.split(';');
                
                scope.$on('propertyChanged', function (event, name) {

                    if (_.indexOf(scope.linkedParent, name) > -1) {

                        if (scope.model.length > 0) {
                            scope.$apply(function () { scope.model = []; });
                            $rootScope.$broadcast('propertyChanged', attributes.name);
                        }

                        element.find('#multiselectStatus').removeClass('multiselect-arrow').addClass('k-loading multiselect-loading');

                        scope.populate().then(function () {
                            element.find('#multiselectStatus').removeClass('k-loading multiselect-loading').addClass('multiselect-arrow');
                        });
                    }
                })
            }

            var repositionList = function () {
                if (scope.initialHeight !== element.outerHeight()) {
                    scope.initialHeight = element.outerHeight();
                    scope.list.css('top', element.offset().top + scope.initialHeight);
                }
            }

            scope.addSelected = function (id, text, value) {
                $timeout(function () {
                    scope.list.find('li.list-highlight').removeClass('list-highlight');
                    scope.$apply(function () { scope.model.push({ id: id, text: text, value: value }) });
                    $rootScope.$broadcast('propertyChanged', attributes.name);
                    if (scope.clearInput) { scope.inputText = ''; }
                    repositionList(); // we need to reposition the list if the selected items have expanded the height
                })
            }

            scope.removeItem = function (e, id) {
                e.stopPropagation();

                el.find('[data-item-index="' + id + '"]').removeClass('k-state-selected');
                $timeout(function () {
                    var idIndex = _.findIndex(scope.model, { 'id': id });

                    scope.model.splice(idIndex, 1);
                    scope.$apply();
                    $rootScope.$broadcast('propertyChanged', attributes.name);
                    repositionList(); // we need to reposition the list if the selected items have expanded the height
                });
            }


          scope.$on('propertiesLoaded', function () {
              if (scope.defaultValue) {
                var arr = angular.fromJson(scope.defaultValue.replace(/'/g, '"'))
                for (var i = 0; i < arr.length; i++) {
                    var id = 'auto' + i;
                    scope.addSelected(id, arr[i], id);
                }
            }

            if (scope.autoBind) {
              scope.populate();
            }
          });



            scope.showList = function () {

                if(el.children('li:not(.hidden)').length > 0) {
                    if (scope.filterList) { el.children('li:not(.hidden):first').addClass('list-highlight'); }

                    var position = element.offset();
                    var elementWidth = element.outerWidth();
                    scope.initialHeight = element.outerHeight();

                    scope.list.css({ 'left': position.left, 'top': position.top + scope.initialHeight, 'width': elementWidth});
                    scope.list.removeClass('hidden');
                }
            }

            scope.hideList = function (clear) {
                if (scope.clearInput === true && clear !== false) { $timeout(function () { scope.$apply(function () { scope.inputText = '' }); }); }
                scope.list.find('li.list-highlight').removeClass('list-highlight');
                scope.list.addClass('hidden');
                w.unbind('click mousedown');
            }

            element.bind('click', function (e) {
                
                scope.textBox.focus();

                if (scope.list.hasClass('hidden')) {
                    if (el.children().length > 0) {
                        scope.showList();
                    } else {
                        element.find('#multiselectStatus').removeClass('multiselect-arrow').addClass('k-loading multiselect-loading')

                        scope.populate().then(function (hasItems) {
                            element.find('#multiselectStatus').removeClass('k-loading multiselect-loading').addClass('multiselect-arrow');
                            hasItems ? scope.showList() : scope.list.addClass('hidden');
                        });
                    }

                    $timeout(function () {
                        w.on('click mousedown', function (e) {
                            scope.hideList();
                        })
                    })

                    var dialog = $("#importDialog").data("kendoWindow");

                    if (dialog) {
                        dialog.bind("resize", function () { scope.hideList(); dialog.unbind('resize'); });
                    }

                } else {
                    scope.hideList(false);
                }
            }).mousedown(function (e) { e.stopPropagation(); })

            scope.$watch('inputText', function (newValue, oldValue) {
                if (scope.typeTimer) { window.clearTimeout(scope.typeTimer); }
                if ((newValue !== oldValue)) {
                    scope.setInputWidth();
                    scope.typeTimer = window.setTimeout(function () {
                        if (scope.filterList) {
                            scope.list.find('li.list-highlight').removeClass('list-highlight');
                            if (scope.serverFiltering) {
                                scope.populate().then(function (hasItems) {
                                    hasItems && scope.inputText !== '' ? scope.showList() : scope.hideList(false);
                                });
                            } else {
                                el.children('li').removeClass('hidden');
                                el.children('li')
                                  .filter(function (index) {
                                      return $(this).html().toLowerCase().indexOf(scope.inputText.toLowerCase()) !== 0;
                                  }).addClass('hidden');

                                el.children('li').not('.hidden').length > 0 && scope.inputText !== '' ? scope.showList() : scope.hideList(false);
                            }
                        }
                    }, 500);
                }
            })

            element.bind('keydown', function (event) {
                var lit = null;
                switch (event.keyCode) {
                    case 8: // backspace
                        scope.$apply(function () {
                            if ((scope.inputText === null || scope.inputText.length === 0) && scope.model.length !== 0) {
                                el.find('[data-item-index="' + _.last(scope.model).id + '"]').removeClass('k-state-selected');
                                scope.model.pop();
                                $timeout(function () { 
                                    repositionList();
                                    $rootScope.$broadcast('propertyChanged', attributes.name);
                                })
                            }
                        });
                        break;
                    case 9: // tab
                        if (!scope.list.hasClass('hidden')) {
                            if(scope.list.find('li.list-highlight').length > 0) {
                                scope.list.find('li.list-highlight').click();
                                event.preventDefault();
                            }
                            
                        }
                        break;
                    case 13: // enter
                        scope.list.find('li.list-highlight').click();
                        event.preventDefault();
                        break;
                    case 17: // ctrl
                        event.preventDefault();
                        break;
                    case 27: // escape
                        scope.list.find('li.list-highlight').removeClass('list-highlight');
                        scope.hideList();
                        event.preventDefault();
                        break;
                    case 38: // up arrow
                        lit = scope.list.find('li.list-highlight');

                        if (lit.prev().length !== 0) {
                            scrollToElement(scope.list, lit.prev())
                            lit.removeClass('list-highlight').prev().addClass('list-highlight');
                        } else {
                            lit.removeClass('list-highlight');
                            scope.list.addClass('hidden');
                        }

                        event.preventDefault();
                        break;
                    case 40: // down arrow
                        lit = scope.list.find('li.list-highlight');

                        if (lit.length === 0) {
                            scope.list.find('li').first().addClass('list-highlight');
                            scope.list.removeClass('hidden');
                        } else {
                            if (lit.next().length !== 0) {
                                scrollToElement(scope.list, lit.next())
                                lit.removeClass('list-highlight').next().addClass('list-highlight');
                            }
                        }

                        event.preventDefault();
                        break;
                    default:
                        break;
                }
            });

            scope.setInputWidth = function () {

                var spanWidth = scope.textBox.siblings('span').width() + 4;
                var parentWidth = element.children('.multiselected').width();
                var textWidth;
                
                if (spanWidth < 25) {
                    textWidth = 25; 
                } else if (spanWidth > parentWidth) {
                    textWidth = parentWidth;
                } else {
                    textWidth = spanWidth + 4;
                }

                scope.textBox.css('width', textWidth + 'px');
            }

            var scrollToElement = function (list, element, offset) {
                var elementTop = element.prop('offsetTop');
                var elementHeight = element.outerHeight() + 2;
                var parentHeight = list.prop('clientHeight');
                var parentScrollTop = list.scrollTop();
 
                if (elementTop < parentScrollTop) {
                    list.scrollTop(elementTop - 2);
                }
                else if (elementTop + elementHeight > parentHeight + parentScrollTop) {
                    list.scrollTop(elementTop + elementHeight - parentHeight);
                }
            }

          scope.canceler = null;

            scope.populate = function () {

                var defer = $q.defer();
                var hasItems = false;

                if ((scope.typeToBind && scope.inputText.length >= CharacterThreshold) || !scope.typeToBind) {

                  if (scope.canceler) { scope.canceler.resolve(); } //cancel any pending request

                  var promises = scope.wtDataSource({ q: scope.inputText });
                  scope.canceler = promises.canceler;

                  promises.deferred.promise.then(function (data) {
                        if (data.length > 0) {

                            hasItems = true;

                            var i = 0;
                            var s = '';

                            var mv = element.find('.multi-value');

                            _.forEach(data, function (value) {
                                // custom search might add values before we have the list
                                // we'll need to select them
                                var o = _.find(scope.model, { text: value.name })
                                if (scope.model.length > 0 && o) {
                                    var e = $(_.find(mv, function (x) { return x.textContent === value.name }));
                                    e.parent().attr('id', value.id);
                                    o.id = value.id;
                                    s += '<li data-item-index=' + i + ' data-value="' + value.id + '" class="k-state-selected">' + value.name + '</li>';
                                } else {
                                    s += '<li data-item-index=' + i + ' data-value="' + value.id + '">' + value.name + '</li>';
                                }

                                i++;
                            })

                            el.html(s);
                            data = null;

                            el.find('li').bind('click', function (e) {
                                e.stopPropagation();

                                var id = $(this).attr('data-item-index');
                                var value = $(this).attr('data-value');

                                if (angular.element(this).hasClass('k-state-selected')) {
                                    scope.removeItem(e, id);
                                    angular.element(this).removeClass('k-state-selected');
                                } else {
                                    scope.addSelected(id, $(this).text(), value);
                                    angular.element(this).addClass('k-state-selected');
                                }

                                if (!e.ctrlKey && !e.metaKey) {
                                    scope.hideList(false);
                                }

                            })

                            if (el.find('li').length === 1 && scope.autoPopulate && !scope.defaultValue) {
                                el.find('li').click();
                            }

                            $timeout(function () { scope.defaultValue = null; })
                        } else {
                            hasItems = false;
                            scope.list.addClass('hidden');
                            el.empty();
                        }

                        defer.resolve(hasItems);
                    })
                } else {
                    el.empty();
                    defer.resolve(false)
                }

                return defer.promise;
            }
        }
    };
}]);